import React from 'react'
import './Styles/CREDocumentoTributario.css'
import {useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import SETablaResumen from './CRETablaResumen'
import { generateQRImageFromBits, getLogoEmpresa } from '../../../../actions/operaciones/operaciones.actions'
import { unirChipsJoin, unirChipsReturnFirst } from '../../../../utils/strings.utils'

const CREDocumentoTributario = () => {
  const {formCliente, datosEmisor, datosFacturaRes, datosUUID, formSucursal, catalogoSucursal} = useSelector((state: State) => state.comprobanteRetencion)
  const {municipios} = useSelector((state: State) => state.catalogos)
  const datos = useSelector((state: State) => state.userLogin.datos)
  const datosReceptor = useSelector((state: State) => state.documentos.datosReceptor.form)

  return (
    <>
      <div className='dt-center-content'>
        <h1 className='dt-title-h1' style={{textAlign:"center"}}>{datosFacturaRes.JsonFactura ? "" : "PREVISUALIZACIÓN DE"} DOCUMENTO TRIBUTARIO ELECTRÓNICO <br/>COMPROBANTE DE RETENCIÓN</h1>
        <div className='form-separator'></div>

        <div className='dt-card-grid-2c-1r' style={{alignItems: 'center'}}>
          <div className='dt-card-2c-1r-no-border' style={{textAlign: 'center'}}>
            <img src={getLogoEmpresa()} alt='Logo' className='logo-itprofis' />
          </div>

          <div className='dt-card-2c-1r'>
            <div className='dt-center-content'>
              <div className='dt-1r-c2'>
                <div className='detail'>
                  <label>Documento Tributario Electrónico Versión:</label>
                  <label>{datosUUID?.Version || ''}</label>
                </div>
                <div className='detail'>
                  <label>Código de Generación:</label>
                  <label>{datosUUID?.CodigoGeneracion || ''}</label>
                </div>
                <div className='detail'>
                  <label>Moneda:</label>
                  <label>USD - Dólar estadounidense</label>
                </div>
                <div className='detail'>
                  <label>Sucursal:</label>
                  <label>
                    {catalogoSucursal?.find((sucursal) => sucursal?.idsucursal === formSucursal?.sucursal)?.nombre || ''}
                  </label>
                </div>
                <div className='detail'>
                  <label>Serie:</label>
                  <label>{`${formSucursal?.datosSerie?.serie} - ${formSucursal?.datosSerie?.numeroactual}`}</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='dt-card-grid-2c-1r'>
          <div className='dt-card-2c-1r'>
            <div className='dt-center-content'>
              <h2 className='dt-title-h2'>Sujeto de retención (receptor)</h2>
              <div className='dt-1r-c2'>
                <div className='detail'>
                  <label>Nombre o Razón Social:</label>
                  <label>{formCliente.nombre || ''}</label>
                </div>
                <div className='detail'>
                  <label>Tipo de doc de identificación:</label>
                  <label>{formCliente.nombreTipoDocumento || ''}</label>
                </div>
                <div className='detail'>
                  <label>No. doc de identificación:</label>
                  <label>{formCliente.numId || ''}</label>
                </div>
                <div className='detail'>
                  <label>Correo electrónico:</label>
                  <label>{unirChipsReturnFirst(formCliente.chipsEmail!, formCliente.email!) ?? ''}</label>
                </div>
                <div className='detail'>
                  <label>Teléfono celular:</label>
                  <label>{formCliente.telefono || ''}</label>
                </div>
                <div className='detail'>
                  <label>Departamento:</label>
                  <label style={{textTransform:"uppercase"}}>{formCliente.nombreDepartamento || ''}</label>
                </div>
                <div className='detail'>
                  <label>Municipio:</label>
                  <label>{formCliente?.municipio ? municipios?.find((el) => formCliente.municipio === el.codigo)?.valor : ''}</label>
                </div>
                <div className='detail'>
                  <label>Dirección:</label>
                  <label>{formCliente.direccion || ''}</label>
                </div>
                <div className='detail'>
                  <label>NRC:</label>
                  <label>{formCliente.nrc || ''}</label>
                </div>
                <div className='detail'>
                  <label>Actividad:</label>
                  <label>{formCliente?.actividad ? `${formCliente.actividad}-${formCliente.descripcion}` : ''}</label>
                </div>
                <div className='detail'>
                  <label>Envío de documento por correo electrónico a:</label>
                  <label>{unirChipsJoin(formCliente.chipsEmail!, formCliente.email!) ?? ''}</label>
                </div>
              </div>
            </div>
          </div>

          <div className='dt-card-2c-1r'>
            <div className='dt-center-content'>
              <h2 className='dt-title-h2'>Agente de retención</h2>
              <div className='dt-1r-c2'>
                <div className='detail'>
                  <label>Tipo de persona:</label>
                  <label>{datosEmisor?.desTipoEmpresa ?? ''}</label>
                </div>
                <div className='detail'>
                  <label>Tipo contribuyente:</label>
                  <label>{datosEmisor?.desContribuyente ?? ''}</label>
                </div>
                <div className='detail'>
                  <label>Nombre del cliente:</label>
                  <label>{datosEmisor?.nombre ?? ''}</label>
                </div>
                <div className='detail'>
                  <label>Dirección:</label>
                  <label>{datosEmisor?.complemento ?? ''}</label>
                </div>
                <div className='detail'>
                  <label>Departamento:</label>
                  <label>{datosEmisor?.departamento?.valor ?? ''}</label>
                </div>
                <div className='detail'>
                  <label>Municipio:</label>
                  <label>{datosEmisor?.municipio?.valor ?? ''}</label>
                </div>
                <div className='detail'>
                  <label>Giro:</label>
                  <label>{datosEmisor?.descactividad ?? ''}</label>
                </div>
                <div className='detail'>
                  <label>NIT:</label>
                  <label>{datosEmisor?.nit ?? ''}</label>
                </div>
                <div className='detail'>
                  <label>Teléfono celular:</label>
                  <label>{datosEmisor?.telefono ?? ''}</label>
                </div>
                <div className='detail'>
                  <label>NRC:</label>
                  <label>{datosEmisor?.nrc ?? ''}</label>
                </div>
                <div className='detail'>
                  <label>Correo electrónico:</label>
                  <label>{datosEmisor?.correo ?? ''}</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='dt-card w-100 text-center'><SETablaResumen /></div>

        <div className='dt-card w-100 text-center' style={{padding: 0}}>
          {!datosFacturaRes?.qr && (
            <div className='dt-card-grid-2c'>
              <div className='detail'>
                <label>Responsable por parte del Emisor:</label>
                <label>{datos?.name}</label>
              </div>
              <div className='detail'>
                <label>{datos?.tipo_documento || 'N° de Documento'}:</label>
                <label>{datos?.documento}</label>
              </div>
              <div className='detail'>
                <label>Responsable por parte del Receptor:</label>
                <label>{datosReceptor.nombre ? datosReceptor.nombre : formCliente.nombre}</label>
              </div>
              <div className='detail'>
                <label>{datosReceptor.nombreTipoDocumento ? `${datosReceptor.nombreTipoDocumento}:` : formCliente.nombreTipoDocumento ? `${formCliente.nombreTipoDocumento}:`: ''}</label>
                <label>{datosReceptor.nombreTipoDocumento ? datosReceptor.numId : formCliente.numId}</label>
              </div>
            </div>
          )}

          {datosFacturaRes?.qr && (
            <div className='dt-card-grid-3c'>
              <div>
                <img src={generateQRImageFromBits(datosFacturaRes?.qr.replace('data:image/jpeg;base64,', ''))} alt='qr' className='dt-img-qr'
                />
              </div>
              <div className='dt-card-2c-responsive'>
                <div className='detail'>
                  <label>Responsable por parte del Emisor:</label>
                  <label>{datos?.name}</label>
                </div>
                <div className='detail'>
                  <label>Responsable por parte del Receptor:</label>
                  <label>{datosReceptor.nombre ? datosReceptor.nombre : formCliente.nombre}</label>
                </div>
              </div>
              <div className='dt-card-2c-responsive'>
                <div className='detail'>
                  <label>{datos?.tipo_documento || 'N° de Documento'}:</label>
                  <label>{datos?.documento}</label>
                </div>
                <div className='detail'>
                  <label>{datosReceptor.nombreTipoDocumento ? `${datosReceptor.nombreTipoDocumento}:` : formCliente.nombreTipoDocumento ? `${formCliente.nombreTipoDocumento}:`: ''}</label>
                  <label>{datosReceptor.nombreTipoDocumento ? datosReceptor.numId : formCliente.numId}</label>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default CREDocumentoTributario
